import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { BASE_ASSET_URL, MODAL_CONFIRM_BUTTON_LABEL } from "../config.ts";

export default function ModalInfoStromverbrauch() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <img className="panel__img"  src={BASE_ASSET_URL+"Durchschnittliche_Stromverbraeuche_nach_Personen_250521.png"} />
            <Button label={"weiter"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>)
}

